/**
 * @components home-media
 * @author 陈恩浩
 */

import React, { Component } from "react";
import "./index.scss";

class WhyHatu extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {}

  render() {
    return (
      <div className="home-medie">
        <div className="inner">
          <div className="inner-title">央视报道 放心选择</div>
          <video
            className="video"
            controls
            poster={require("@/images/home/cover.jpg")}
          >
            <source src={require("@/images/home/cctv4.mp4")} type="video/mp4" />
          </video>
        </div>
      </div>
    );
  }
}

export default WhyHatu;
